import React from "react";

type ChatbotData = {
  AVATAR_URL?: string;
};

const ChatbotPreview: React.FC = () => {
  const chatBotData: ChatbotData = JSON.parse(
    sessionStorage.getItem("Chatbot") || "{}"
  );
  const createdChatbotAvatar = JSON.parse(
    sessionStorage.getItem("CreateChatbotAvatar") || "{}"
  );

  const avatarUrl = chatBotData?.AVATAR_URL;
  const avatarVideoUrl = createdChatbotAvatar?.TRAINING_CONTENT_URL;

  return (
    <div style={{ textAlign: "left", marginTop: "2vh" }}>
      {/* <h2 className="text-[2.3vh] font-manropeSB">Avatar</h2> */}
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt="Chatbot Avatar"
          style={{
            width: "30vh",
            height: "30vh",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : avatarVideoUrl ? (
        <video
          src={avatarVideoUrl}
          controls
          style={{
            width: "30vh",
            height: "30vh",
            objectFit: "cover",
          }}
        >
          Your browser does not support the video tag.
        </video>
      ) : (
        <p>No avatar selected.</p>
      )}
    </div>
  );
};

export default ChatbotPreview;
